<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
   <div class="save-panel">
          <button class="btn btn-sm btn-warning btn-icon" @click="updateItem">
               <span class="ti-save"></span>Сохранить
          </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "warehouse/options",
    cardSetLink: "warehouse/options",
    item: null,
    fields: [
         {
        col:' col-12 col-md-12',
        key: "product",
        label: "Группа",
        type: "select",
        selectKey: "display_name",
        modal: "product",
      },
      // {
      //   col:' col-12 col-md-12',
      //   key: "categories",
      //   label: "Категории (тут оставим?)",
      //   type: "selects",
      //   selectKey: "title",
      //   modal: "category",
      // },
      {
        col:' col-12 col-md-12',
        key: "is_active",
        label: "Активен",
        type: "checkbox",
      },
      {
        col:' col-12 col-md-6',
        key: "name",
        label: "Название модификации",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-6',
        key: "sku",
        label: "SKU",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-6',
        key: "barcode",
        label: "Штрихкод",
        type: "mask",
        mask: "#############",
        textType: "number",
      },
      {
        col:' col-12 col-md-6',
        key: "quantity",
        label: "Количество",
        type: "field",
        textType: "number",
      },
      {
         col:' col-12 col-md-6',
        key: "reward",
        label: "Награда",
        type: "field",
        textType: "number",
      },
      {
        col:' col-12 col-md-6',
        key: "price",
        label: "Цена",
        type: "field",
        textType: "number",
      },
      {
        col:' col-12 col-md-6',
        key: "price_retail",
        label: "Розничная цена",
        type: "field",
        textType: "number",
      },
      {
        col:' col-12 col-md-6',
        key: "price_old",
        label: "Старая цена",
        type: "field",
        textType: "number",
      },
      {
        col:' col-12 col-md-6',
        key: 'super_dealer_price',
        label: "Super dealer price",
        type: "field",
        textType: "number",
      },
      {
        col:' col-12 col-md-6',
        key: 'dealer_price',
        label: "Dealer price",
        type: "field",
        textType: "number",
      },
      {
        col:' col-12 col-md-6',
        key: 'wholesale_price',
        label: "Wholesale price",
        type: "field",
        textType: "number",
      },
      {
        col:' col-12 col-md-6',
        key: 'msrp_price',
        label: "Msrp price",
        type: "field",
        textType: "number",
      }
    ],
  }),

  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
    },
  },
};
</script>
<style>
</style>
